module.exports = __webpack_public_path__ + "static/media/styleship.309d8652.jpg";